import { ReservationArrivalTransferModeDto, ReservationFlightArrivalTransferMode, ReservationOtherArrivalTransferMode, isReservationFlightArrivalTransferMode, isReservationOtherArrivalTransferMode } from './ReservationArrivalTransferMode';
import { ReservationDepartureTransferModeDto, ReservationFlightDepartureTransferMode, ReservationOtherDepartureTransferMode, isReservationFlightDepartureTransferMode, isReservationOtherDepartureTransferMode } from './ReservationDepartureTransferMode';
import { ReservationState } from './types';

export interface ReservationArrivalTransferDetailsDto {
    mode: ReservationArrivalTransferModeDto;
}

export interface ReservationDepartureTransferDetailsDto {
    mode: ReservationDepartureTransferModeDto;
}

export function hydrateReservationArrivalTransferDetails(reservation: ReservationState) {

    const isDirty = () => {

        if (reservation.ArrivalTransferDetails.Mode.isDirty) {
            return true;
        }

        if (isReservationFlightArrivalTransferMode(reservation.ArrivalTransferDetails.Mode.value)) {
            return isReservationFlightArrivalTransferModeDirty(reservation.ArrivalTransferDetails.Mode.value);
        } else if (isReservationOtherArrivalTransferMode(reservation.ArrivalTransferDetails.Mode.value)) {
            return isReservationOtherArrivalTransferModeDirty(reservation.ArrivalTransferDetails.Mode.value);
        }

        return false;
    }

    const signal = () => {
        reservation.ArrivalTransferDetailsIsDirty.setValue(isDirty());
        reservation.ArrivalTransferDetailsVersion.setValue(reservation.ArrivalTransferDetailsVersion.value + 1);
    };

    // Amount strategy
    let oldReservationArrivalTransferDetailsSubscription: () => void = null;

    function subscribeReservationArrivalTransferDetails() {
        if (reservation.ArrivalTransferDetails.Mode.value) {
            const mode = reservation.ArrivalTransferDetails.Mode.value;

            if (isReservationFlightArrivalTransferMode(mode)) {
                oldReservationArrivalTransferDetailsSubscription = hydrateReservationFlightArrivalTransferMode(mode, signal);
            } else if (isReservationOtherArrivalTransferMode(mode)) {
                oldReservationArrivalTransferDetailsSubscription = hydrateReservationOtherArrivalTransferMode(mode, signal);
            } else {
                oldReservationArrivalTransferDetailsSubscription = () => { };
            }
        } else {

            oldReservationArrivalTransferDetailsSubscription = () => { };
        }
    }

    subscribeReservationArrivalTransferDetails();

    const unsubscribeReservationArrivalTransferDetails = reservation.ArrivalTransferDetails.Mode.subscribe(() => {
        oldReservationArrivalTransferDetailsSubscription?.();

        subscribeReservationArrivalTransferDetails();

        signal();
    });

    return unsubscribeReservationArrivalTransferDetails;
}

function hydrateReservationFlightArrivalTransferMode(status: ReservationFlightArrivalTransferMode, signal: () => void) {
    const subscriptions = [
        status.FlightNumber.subscribe(() => {
            signal()
        }),
        status.ArrivalTime.subscribe(() => {
            signal()
        }),
        status.Details.subscribe(() => {
            signal()
        }),
    ]

    return () => {
        subscriptions.forEach(s => s());
    };
}

function isReservationFlightArrivalTransferModeDirty(status: ReservationFlightArrivalTransferMode) {
    return status.FlightNumber.isDirty
        || status.ArrivalTime.isDirty
        || status.Details.isDirty;
}


function hydrateReservationOtherArrivalTransferMode(status: ReservationOtherArrivalTransferMode, signal: () => void) {
    const subscriptions = [
        status.Details.subscribe(() => {
            signal()
        }),
    ]

    return () => {
        subscriptions.forEach(s => s());
    };
}

function isReservationOtherArrivalTransferModeDirty(status: ReservationOtherArrivalTransferMode) {
    return status.Details.isDirty;
}






export function hydrateReservationDepartureTransferDetails(reservation: ReservationState) {

    const isDirty = () => {

        if (reservation.DepartureTransferDetails.Mode.isDirty) {
            return true;
        }

        if (isReservationFlightDepartureTransferMode(reservation.DepartureTransferDetails.Mode.value)) {
            return isReservationFlightDepartureTransferModeDirty(reservation.DepartureTransferDetails.Mode.value);
        } else if (isReservationOtherDepartureTransferMode(reservation.DepartureTransferDetails.Mode.value)) {
            return isReservationOtherDepartureTransferModeDirty(reservation.DepartureTransferDetails.Mode.value);
        }

        return false;
    }

    const signal = () => {
        reservation.DepartureTransferDetailsIsDirty.setValue(isDirty());
        reservation.DepartureTransferDetailsVersion.setValue(reservation.DepartureTransferDetailsVersion.value + 1);
    };

    // Amount strategy
    let oldReservationDepartureTransferDetailsSubscription: () => void = null;

    function subscribeReservationDepartureTransferDetails() {
        if (reservation.DepartureTransferDetails.Mode.value) {
            const mode = reservation.DepartureTransferDetails.Mode.value;

            if (isReservationFlightDepartureTransferMode(mode)) {
                oldReservationDepartureTransferDetailsSubscription = hydrateReservationFlightDepartureTransferMode(mode, signal);
            } else if (isReservationOtherDepartureTransferMode(mode)) {
                oldReservationDepartureTransferDetailsSubscription = hydrateReservationOtherDepartureTransferMode(mode, signal);
            } else {
                oldReservationDepartureTransferDetailsSubscription = () => { };
            }
        } else {

            oldReservationDepartureTransferDetailsSubscription = () => { };
        }
    }

    subscribeReservationDepartureTransferDetails();

    const unsubscribeReservationDepartureTransferDetails = reservation.DepartureTransferDetails.Mode.subscribe(() => {
        oldReservationDepartureTransferDetailsSubscription?.();

        subscribeReservationDepartureTransferDetails();

        signal();
    });

}

function hydrateReservationFlightDepartureTransferMode(status: ReservationFlightDepartureTransferMode, signal: () => void) {
    const subscriptions = [
        status.FlightNumber.subscribe(() => {
            signal()
        }),
        status.DepartureTime.subscribe(() => {
            signal()
        }),
        status.Details.subscribe(() => {
            signal()
        }),
    ]

    return () => {
        subscriptions.forEach(s => s());
    };
}

function isReservationFlightDepartureTransferModeDirty(status: ReservationFlightDepartureTransferMode) {
    return status.FlightNumber.isDirty
        || status.DepartureTime.isDirty
        || status.Details.isDirty;
}


function hydrateReservationOtherDepartureTransferMode(status: ReservationOtherDepartureTransferMode, signal: () => void) {
    const subscriptions = [
        status.Details.subscribe(() => {
            signal()
        }),
    ]

    return () => {
        subscriptions.forEach(s => s());
    };
}

function isReservationOtherDepartureTransferModeDirty(status: ReservationOtherDepartureTransferMode) {
    return status.Details.isDirty;
}

